import Swiper from 'swiper'
import { A11y, Autoplay, EffectCoverflow, EffectFade, Navigation, Pagination } from 'swiper/modules'

const body  = document.querySelector('body');
const home  = body.classList.contains('home');

if (home) {

    // ---------------------- SWIPERS PUBLICATIONS & ADMIN AREAS -------------------------------------
    // Get every swiper on the page
    const swiper = document.querySelectorAll('.model-swiper');

    for (let i = 0; i < swiper.length; i++) {
        let itemClass = `swiper_item_${i}`;
        // Add class for each items
        swiper[i].classList.add(itemClass);

        let config = {
            modules: [ A11y, EffectFade, Navigation ],

            effect : 'slide',
            grabCursor : 'true',
            speed: 700,
            loop : false,
            spaceBetween: 30,

            breakpoints: {
                1201: {
                    spaceBetween: 30,
                },
                961: {
                    spaceBetween: 20,
                },
                641: {
                    slidesPerView : 2,
                    spaceBetween: 20,
                },
                0: {
                    slidesPerView : 1,
                    spaceBetween: 20
                }
            },

            navigation: {
                nextEl: `.model-swiper.${itemClass} .nav-swiper--next`,
                prevEl: `.model-swiper.${itemClass} .nav-swiper--prev`,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },
        }
    
        // Specific config between different sliders


        // PUBLICATIONS
        // -------------------------------------------------------- Model m-fp-3_slides ----
        if(swiper[i].classList.contains('m-fp-3_slides')) {
            
            // Configs
            config.slidesPerView = 3;

            // console.log('m-fp-3_slides');
        }
    
        // -------------------------------------------------------- Model m-fp-2_slides ----
        else if(swiper[i].classList.contains('m-fp-2_slides')) {
    
            // Configs
            config.slidesPerView = 2;
    
            // console.log('m-fp-2_slides');
        }

        // -------------------------------------------------------- Model m-fp-1_big_3_slides ----
        else if(swiper[i].classList.contains('m-fp-1_big_3_slides')) {

            // Configs
            config.slidesPerView = 3;
    
            // console.log('m-fp-1_big_3_slides');
        }



        // ADMIN AREA
        // -------------------------------------------------------- Model m-fa-5_sliding_blocs ----
        else if(swiper[i].classList.contains('m-fa-5_sliding_blocs')) {

            // Configs
            config.slidesPerView = 5;
            config.breakpoints = {
                1201: {
                    spaceBetween: 30,
                },
                961: {
                    slidesPerView : 5,
                    spaceBetween: 20
                },
                641: {
                    slidesPerView : 4,
                    spaceBetween: 20
                },
                0: {
                    slidesPerView : 2,
                    spaceBetween: 20
                }
            }
    
            // console.log('m-fa-5_sliding_blocs');
        }

        // -------------------------------------------------------- Model m-fa-1_sliding_bloc ----
        else if(swiper[i].classList.contains('m-fa-1_sliding_bloc')) {

            // Configs
            config.effect = "fade";
            config.fadeEffect = {
                crossFade: true
            };
            config.slidesPerView = 1;
            config.breakpoints = {
                641: {
                    slidesPerView : 1,
                },
                0: {
                    slidesPerView : 1,
                }
            }
    
            // console.log('m-fa-1_sliding_bloc');
        }

        // -------------------------------------------------------- Model m-fa-2_sliding_blocs ----
        else if(swiper[i].classList.contains('m-fa-2_sliding_blocs')) {

            // Configs
            config.slidesPerView = 2;
    
            // console.log('m-fa-2_sliding_blocs');
        }


        // Call swiper for every sliders with custom config
        let swiperBasic = new Swiper(`.model-swiper.${itemClass} .swiper`, config);
    }


    // ---------------------- SWIPER SLIDESHOW -------------------------------------
    const swiperSlideshow = document.querySelector('.model-swiper-slideshow') !== null;

    if (swiperSlideshow) {
        
        let nbSlides = document.querySelectorAll('.model-swiper-slideshow .swiper .swiper-slide').length;
        let dataSlideAuto = document.querySelector('.model-swiper-slideshow .swiper').getAttribute('data-slide_auto'); //.dataset.slideAuto
        let dataSlideSpeed = document.querySelector('.model-swiper-slideshow .swiper').getAttribute('data-slide_speed');
        dataSlideSpeed = dataSlideSpeed + '000';
        let dataNav = document.querySelector('.model-swiper-slideshow .swiper').getAttribute('data-nav');

        let config = {
            modules: [ A11y, Autoplay, EffectFade, Navigation, Pagination ],

            grabCursor : 'true',
            speed: 700,
            loop : true,

            effect : 'fade',
            fadeEffect: {
                crossFade: true,
            },
            
            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },
        }

        if(dataNav === 'arrows') {
            config.navigation = {
                nextEl: `.model-swiper-slideshow .nav-swiper--next`,
                prevEl: `.model-swiper-slideshow .nav-swiper--prev`,
            }
            // console.log('arrows')
        }

        if(dataNav === 'chips') {
            config.pagination = {
                el: '.model-swiper-slideshow .c-pagination__bullets',
                type: 'bullets', // default
                clickable: true
            }
            // console.log('chips')
        }

        if(dataSlideAuto === '1') {
            config.autoplay = {
                delay: dataSlideSpeed,
                disableOnInteraction: false
            }
        }
        
        if(nbSlides > 1) {
            let swiperHomeSlideshow = new Swiper(`.model-swiper-slideshow .swiper`, config)
            
            if(dataSlideAuto === '1') {
                let boutonPlayPause = document.getElementById('js-boutonAutoplay')

                boutonPlayPause.addEventListener('click', function () {

                    if(swiperHomeSlideshow.autoplay.running === true) {
                        swiperHomeSlideshow.autoplay.stop();

                        boutonPlayPause.classList.remove('nav-swiper-autoplay--play')
                        boutonPlayPause.classList.add('nav-swiper-autoplay--pause');

                        // console.log('autoplay running : ' + swiperHomeSlideshow.autoplay.running);
                    }

                    else {
                        swiperHomeSlideshow.autoplay.start();

                        boutonPlayPause.classList.remove('nav-swiper-autoplay--pause')
                        boutonPlayPause.classList.add('nav-swiper-autoplay--play');

                        // console.log('autoplay running : ' + swiperHomeSlideshow.autoplay.running);
                    }
                });
            }
        }
    }


    // ---------------------- SWIPER DOCUMENTS -------------------------------------
    const swiperDocs = document.querySelector('.model-swiper-docs') !== null;

    if (swiperDocs) {
        
        let nbSlides = document.querySelectorAll('.model-swiper-docs .swiper .swiper-slide').length;

        let config = {
            modules: [ A11y, EffectFade, Navigation ],

            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            grabCursor : 'true',
            speed: 700,
            loop : true,
            spaceBetween: 30,

            breakpoints: {
                1201: {
                    spaceBetween: 30,
                },
                961: {
                    spaceBetween: 20,
                },
                641: {
                    spaceBetween: 20,
                },
                0: {
                    slidesPerView : 1,
                    spaceBetween: 10
                }
            },

            navigation: {
                nextEl: `.model-swiper-docs .nav-swiper--next`,
                prevEl: `.model-swiper-docs .nav-swiper--prev`,
            },
            
            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },
        }

        if(nbSlides > 1) {
            let swiperDocuments = new Swiper(`.model-swiper-docs .swiper`, config)

            document.querySelectorAll('.model-swiper-docs .swiper-slide .c-docs__button').forEach(x => x.tabIndex = -1);
            document.querySelectorAll('.model-swiper-docs .swiper-slide.swiper-slide-active .c-docs__button').forEach(x => x.tabIndex = 0);

            swiperDocuments.on('transitionEnd', function() {
                document.querySelectorAll('.model-swiper-docs .swiper-slide .c-docs__button').forEach(x => x.tabIndex = -1);
                document.querySelectorAll('.model-swiper-docs .swiper-slide.swiper-slide-active .c-docs__button').forEach(x => x.tabIndex = 0);
            });

        }
    }


    // ---------------------- SWIPER DOCUMENTS COVERFLOW -------------------------------------
    // Slider documents - Images
    const docCoverflowImages = document.querySelector('.swiper-docs-image .swiper') !== null;
    let docCoverflowAll = document.querySelectorAll('.swiper-docs-image .swiper .swiper-slide');
            
    if (docCoverflowImages) {
        let docCoverflowImagesSlides = document.querySelectorAll('.swiper-docs-image .swiper .swiper-slide').length;

        let docCoverflowImagesConfig = {
            modules: [ A11y, Navigation, Autoplay, EffectCoverflow ],
            
            effect: "coverflow",
            grabCursor: true,
            centeredSlides: true,
            slidesPerView: "auto",
            coverflowEffect: {
                scale: 0.95,
                rotate: 0,
                slideShadows: false,
            },

            navigation: {
                prevEl: `.m-coverflow__nav .nav-swiper--prev`,
                nextEl: `.m-coverflow__nav .nav-swiper--next`,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },

            breakpoints: {
                961: {
                    allowTouchMove: false,
                    coverflowEffect: {
                        depth: 170, //profondeur
                        stretch: 50, //écart
                    },
                },

                0: {
                    slidesPerView: 1,
                    spaceBetween: 15,
                    effect : 'slide',
                    allowTouchMove: true,
                }
            }
        }

        if(docCoverflowImagesSlides > 1) {
            let swiperDocCoverflowImages = new Swiper('.swiper-docs-image .swiper', docCoverflowImagesConfig);
        }
    }
       

    // Slider documents - Content
    const docCoverflowContent = document.querySelector('.swiper-docs-infos .swiper') !== null;
            
    if (docCoverflowContent) {
        let docCoverflowContentSlides = document.querySelectorAll('.swiper-docs-infos .swiper .swiper-slide').length;

        let docCoverflowContentConfig = {

            modules: [ A11y, Navigation, Autoplay, EffectFade ],

            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            centeredSlides: true,

            keyboard: {
                enabled: true,
            },

            navigation: {
                prevEl: `.m-coverflow__nav .nav-swiper--prev`,
                nextEl: `.m-coverflow__nav .nav-swiper--next`,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },

            slidesPerView: 1,
            spaceBetween: 0,

            breakpoints: {
                961: {
                    allowTouchMove: false,
                },
                0: {
                    allowTouchMove: true,
                }    
            }
        }

        if (docCoverflowContentSlides > 1) {
            let swiperDocCoverflowContent = new Swiper('.swiper-docs-infos .swiper', docCoverflowContentConfig);

            document.querySelectorAll('.swiper-docs-infos .swiper-slide .c-docs__button').forEach(x => x.tabIndex = -1);
            document.querySelectorAll('.swiper-docs-infos .swiper-slide.swiper-slide-active .c-docs__button').forEach(x => x.tabIndex = 0);

            swiperDocCoverflowContent.on('transitionEnd', function() {
                document.querySelectorAll('.swiper-docs-infos .swiper-slide .c-docs__button').forEach(x => x.tabIndex = -1);
                document.querySelectorAll('.swiper-docs-infos .swiper-slide.swiper-slide-active .c-docs__button').forEach(x => x.tabIndex = 0);
            });
        }
    }



}
